import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6 relative overflow-hidden">
      <div className="absolute inset-0 pattern-girih opacity-20" />
      <div className="relative w-full max-w-md rounded-3xl bg-white border border-sand p-10 shadow-2xl shadow-emerald_deep/10" data-testid="admin-login-card">
        <div className="flex items-center justify-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-emerald_deep text-gold flex items-center justify-center">
            <Lock size={22} />
          </div>
        </div>
        <h1 className="font-serif text-3xl text-center text-ink">Admin Login</h1>
        <p className="text-center text-sm text-ink/60 mt-2">Flint Islamic Center management</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-[10px] uppercase tracking-[0.22em] text-gold font-semibold">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
              className="mt-2 w-full px-4 py-3 rounded-xl border border-sand focus:outline-none focus:border-emerald_deep"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.22em] text-gold font-semibold">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              className="mt-2 w-full px-4 py-3 rounded-xl border border-sand focus:outline-none focus:border-emerald_deep"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-emerald_deep text-cream px-6 py-3.5 text-sm font-semibold uppercase tracking-wider hover:bg-emerald_deep-900 transition-colors disabled:opacity-60"
          >
            {loading && <Loader2 size={14} className="animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
